import React, { Fragment, useRef, useState, useEffect } from 'react';
import Topbar from './Topbar';
import { useNavigate } from 'react-router-dom';
// import Icons from '../../component/svgs/icons';
import { Helmet } from 'react-helmet';
import { Dialog, Transition } from '@headlessui/react';
import { Link } from 'react-router-dom';
import instantSupportDialogIcon from '../../assets/images/instantSupportDialogIcon.svg';
import { getPathForInstantSupport, errorToast, successToast } from '../../utils/helper';
import { CompanyApi } from '../../api/companyApi';
import Loader from '../../component/common/Loader';
import axios from 'axios'; // Make sure axios is imported

const InstantSupportAddCustomNumber = () => {
  const instantSupportBrandImage = useRef(null);
  const [open, setOpen] = useState(false);
  const cancelButtonRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState('');
  const [imagePreview, setImagePreview] = useState('');
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [allocatedNumber, setAllocatedNumber] = useState('');
  const [numberError, setNumberError] = useState('');
  const [email, setEmail] = useState('');
  const [description, setDescription] = useState('');
  const [addUpdateNumberText, setAddUpdateNumberText] = useState('Add');
  const [loading, setLoading] = useState(false);
  // Create a new FormData object
  const { companyId } = JSON.parse(localStorage.getItem('userData')); // userType, token can also be used

  const validatePhoneNumber = (number) => {
    // Basic phone number validation - allows international format
    // Accepts formats like: +44 1234 567890, 01234 567890, etc.
    const phoneRegex = /^(\+\d{1,3}\s?)?\d{3,}$/;
    return phoneRegex.test(number.replace(/\s/g, ''));
  };

  const handlePhoneNumberChange = (e) => {
    let value = e.target.value;

    // Allow only digits, spaces, and an optional leading '+'
    if (/^[+\d\s]*$/.test(value)) {
      // Remove spaces to count only digits
      const digitsOnly = value.replace(/\D/g, '');

      if (digitsOnly.length < 8) {
        setNumberError('Phone number must be greater than 8 digits');
      } else if (digitsOnly.length > 16) {
        setNumberError('Phone number must be lesser than or equal to 15 digits');
      } else {
        setNumberError(''); // Clear error when valid
      }

      setAllocatedNumber(value);
    } else {
      setNumberError('Please enter a valid phone number');
      setNumberError('Please enter a valid phone number');
    }
  };

  const handleUpdateCustomNumber = () => {
    if (!name || !allocatedNumber || !email) {
      errorToast('Please fill all the fields');
      return;
    }

    if (!validatePhoneNumber(allocatedNumber)) {
      setNumberError('Please enter a valid phone number');
      errorToast('Please enter a valid phone number');
      return;
    }

    setLoading(true);
    const formData = new FormData();
    if (selectedImage) {
      formData.append('image', selectedImage);
      formData.append('planImage', selectedImage.type || 'image/png');
    }
    if (description) {
      formData.append('description', description);
    }
    formData.append('name', name);
    // Append other fields
    formData.append('allocatedNumber', allocatedNumber);
    formData.append('email', email);
    formData.append('companyId', companyId);
    CompanyApi.updateCustomNumber(formData)
      .then(async (response) => {
        if (response?.data?.data) {
          setSelectedImage('');
          updateFormFieldStates(response?.data?.data);
          if (response?.data?.meta?.planImageUrl?.uploadURL && selectedImage) {
            await uploadImageToPresignedUrl(
              response.data.meta.planImageUrl.uploadURL,
              selectedImage
            );
          }
          successToast('Custom number has been updated successfully!');
        }
      })
      .catch((error) => {
        console.log(error, 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleAddCustomNumber = () => {
    if (!name || !allocatedNumber || !email) {
      errorToast('Please fill all the fields');
      return;
    }

    if (!validatePhoneNumber(allocatedNumber)) {
      setNumberError('Please enter a valid phone number');
      errorToast('Please enter a valid phone number');
      return;
    }

    setLoading(true);
    const formData = new FormData();
    if (selectedImage) {
      formData.append('image', selectedImage);
      formData.append('planImage', selectedImage.type || 'image/png');
    }
    if (description) {
      formData.append('description', description);
    }
    formData.append('allocatedNumber', allocatedNumber);
    formData.append('email', email);
    formData.append('companyId', companyId);
    formData.append('name', name);
    CompanyApi.addCustomNumber(formData)
      .then(async (response) => {
        if (response?.data?.data) {
          setSelectedImage('');
          setAddUpdateNumberText('Update');
          updateFormFieldStates(response?.data?.data);
          if (response?.data?.meta?.planImageUrl?.uploadURL && selectedImage) {
            // Upload the image to the presigned URL
            await uploadImageToPresignedUrl(
              response.data.meta.planImageUrl.uploadURL,
              selectedImage
            );
          }
          successToast('Custom number has been added successfully!');
        }
      })
      .catch((error) => {})
      .finally(() => {
        setLoading(false);
        navigate(getPathForInstantSupport('/instant-support'));
      });
  };

  const uploadImageToPresignedUrl = async (presignedUrl, imageFile) => {
    try {
      await axios.put(presignedUrl, imageFile, {
        headers: {
          'Content-Type': imageFile.type || 'image/png'
        }
      });
      console.log('Image uploaded successfully to S3');
    } catch (error) {
      console.error('Error uploading image to presigned URL:', error);
      errorToast('Failed to upload image. Please try again.');
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const updateFormFieldStates = (response) => {
    const imageData = response.image;
    // Convert buffer to base64 string if image exists
    if (imageData?.data?.data && imageData?.contentType) {
      try {
        const uint8Array = Array.isArray(imageData.data?.data)
          ? new Uint8Array(imageData.data?.data)
          : new Uint8Array(Object.values(imageData.data?.data));
        const chunkSize = 8192;
        let binary = '';
        for (let i = 0; i < uint8Array.length; i += chunkSize) {
          binary += String.fromCharCode.apply(null, uint8Array.slice(i, i + chunkSize));
        }
        const base64String = btoa(binary);
        const imageUrl = `data:${imageData.contentType};base64,${base64String}`;
        setImagePreview(imageUrl);
      } catch (error) {
        console.error('Error converting image data:', error);
      }
    }

    setName(response?.name);
    setAllocatedNumber(response?.allocatedNumber);
    setEmail(response?.email);
    setDescription(response?.description);
  };

  useEffect(() => {
    if (companyId) {
      setLoading(true);
      CompanyApi.getCustomNumber(companyId)
        .then((response) => {
          console.log('Full Response:', response, response?.status); // Debugging to check the response structure

          if (response?.status === 200) {
            if (response?.data?.data) {
              setAddUpdateNumberText('Update');
              setImagePreview(response?.data?.data?.image || '');
              updateFormFieldStates(response?.data?.data);
            }
          }

          if (response?.status === 404) {
            console.log('404 at getCustomNumber:', response?.data?.message);
          }
        
        })
        .catch((error) => {
          console.error('getCustomNumber API Error:', error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [companyId]);

  return (
    <div className="relative lg:pl-5 lg:mb-[45px]">
      {loading && <Loader />}
      <Helmet>
        <meta charSet="utf-8" />
        <title>B2B | Add Custom Number</title>
      </Helmet>
      <Topbar title={'Instant Support (EAP) '} infoBtn={false} />
      <div className="flex flex-col w-full max-w-4xl mt-12 bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8 shadow-md">
        <h1 className="text-xl mt-2 font-medium leading-9">{addUpdateNumberText} custom number</h1>
        {/* Image Upload start */}
        <div>
          <input
            type="file"
            accept=".jpg, .jpeg, .png"
            className="hidden"
            ref={instantSupportBrandImage}
            onChange={handleImageChange}
          />

          <div
            onClick={() => instantSupportBrandImage.current.click()} // Click div to open file input
            className="flex justify-center mt-8 items-center overflow-hidden rounded-[9px] border-[1.5px] border-[#B6C0F3] border-dashed dark:border-shoorah-darkBgColor w-40 h-40 bg-[#E5EAF9] dark:bg-shoorah-darkBgColor relative cursor-pointer"
          >
            {console.log('image preview', imagePreview)}
            {imagePreview ? (
              <img
                src={imagePreview}
                alt="Selected"
                className="absolute w-full h-full object-cover rounded-[9px]"
              />
            ) : (
              <div className="flex flex-col justify-center items-center">
                <svg
                  className="mb-2 text-shoorah-primary"
                  width="22"
                  height="22"
                  viewBox="0 0 23 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.89999 20.0445H14.3667C18.9222 20.0445 20.7444 18.2223 20.7444 13.6667V8.20004C20.7444 3.64449 18.9222 1.82227 14.3667 1.82227H8.89999C4.34444 1.82227 2.52222 3.64449 2.52222 8.20004V13.6667C2.52222 18.2223 4.34444 20.0445 8.89999 20.0445Z"
                    fill="#B6C0F3"
                    stroke="#313B6B"
                    strokeWidth="1.36667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8.90004 9.11124C9.90643 9.11124 10.7223 8.2954 10.7223 7.28902C10.7223 6.28263 9.90643 5.4668 8.90004 5.4668C7.89366 5.4668 7.07782 6.28263 7.07782 7.28902C7.07782 8.2954 7.89366 9.11124 8.90004 9.11124Z"
                    fill="#B6C0F3"
                    stroke="#313B6B"
                    strokeWidth="1.36667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M3.13263 17.2652L7.62441 14.2494C8.34418 13.7665 9.38285 13.8212 10.0297 14.3769L10.3304 14.6412C11.0411 15.2516 12.1891 15.2516 12.8997 14.6412L16.69 11.3885C17.4006 10.7781 18.5486 10.7781 19.2593 11.3885L20.7444 12.6641"
                    fill="#B6C0F3"
                  />
                  <path
                    d="M3.13263 17.2652L7.62441 14.2494C8.34418 13.7665 9.38285 13.8212 10.0297 14.3769L10.3304 14.6412C11.0411 15.2516 12.1891 15.2516 12.8997 14.6412L16.69 11.3885C17.4006 10.7781 18.5486 10.7781 19.2593 11.3885L20.7444 12.6641"
                    stroke="#313B6B"
                    strokeWidth="1.36667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <h5 className="text-[8px]">
                  Drop the brand <br /> image{' '}
                  <span className="text-shoorah-primary font-medium">here</span>
                </h5>
              </div>
            )}
          </div>
          {selectedImage && (
            <p className="mt-2 text-xs text-gray-600">
              Selected: {selectedImage.name} ({Math.round(selectedImage.size / 1024)} KB)
            </p>
          )}
        </div>
        {/* Image Upload End */}
        <h1 className="text-base mt-10 font-medium leading-9">
          Name <span className="text-red-500">*</span>
        </h1>
        <div className="sm:grid sm:grid-cols-12 gap-2 mt-2 sm:w-[100%] w-full h-10">
          <div className="col-span-1 sm:col-span-7">
            <input
              className="w-full sm:mb-0 rounded-lg px-5 py-2 bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-none focus:outline-none"
              type="text"
              placeholder="Company Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        </div>
        <h1 className="text-base mt-10 font-medium leading-9">
          Phone number <span className="text-red-500">*</span>
        </h1>
        <div className="sm:grid sm:grid-cols-12 gap-2 mt-2 sm:w-[100%] w-full h-10">
          <div className="col-span-1 sm:col-span-7">
            <input
              className={`w-full sm:mb-0 rounded-lg px-5 py-2 bg-shoorah-normanGray border-[1.5px] ${
                numberError ? 'border-red-500' : 'border-shoorah-borderGray'
              } dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-none focus:outline-none`}
              type="text"
              placeholder="Phone number"
              value={allocatedNumber}
              onChange={handlePhoneNumberChange}
            />
            {numberError && <p className="text-red-500 text-xs mt-1">{numberError}</p>}
          </div>
        </div>

        <h1 className="text-base mt-10 font-medium leading-9">
          Email <span className="text-red-500">*</span>
        </h1>
        <div className="sm:grid sm:grid-cols-12 gap-2 mt-2 sm:w-[100%] w-full h-10">
          <div className="col-span-1 sm:col-span-7">
            <input
              className="w-full sm:mb-0 rounded-lg px-5 py-2 bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray dark:text-gray-300 dark:bg-shoorah-darkBgColor dark:border-none focus:outline-none"
              type="text"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>
        <h1 className="text-base mt-10 font-medium leading-9">Description</h1>
        <div className="sm:grid sm:grid-cols-12 gap-2 mt-2 sm:w-[100%] w-full">
          <div className="col-span-1 sm:col-span-7">
            <textarea
              className="w-full h-24 rounded-lg px-5 py-2 bg-[#F5F5F5] border-[1.5px] border-[#E7E8EA] text-gray-700 dark:text-gray-300 dark:bg-shoorah-darkBgColor dark:border-none "
              placeholder="Added Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            ></textarea>
          </div>
        </div>

        <button
          onClick={addUpdateNumberText === 'Add' ? handleAddCustomNumber : handleUpdateCustomNumber}
          className={`w-44 p-2 mt-10 text-base font-normal rounded-full border shadow-sm ${
            !name || !allocatedNumber || !email
              ? 'bg-gray-100 dark:bg-shoorah-commonBlack text-gray-400 cursor-not-allowed border-gray-300'
              : 'bg-shoorah-active dark:bg-shoorah-secondary text-white cursor-pointer border-shoorah-active'
          }`}
          disabled={!name || !allocatedNumber || !email}
        >
          {addUpdateNumberText} Number
        </button>
      </div>

      {/* Dialog Box */}
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-50" initialFocus={cancelButtonRef} onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 dark:bg-black !bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor text-left shadow-xl transition-all sm:my-8 sm:w-[calc(100%-2rem] md:max-w-5xl">
                  <div className="bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor dark:border-none p-8 md:py-16 md:px-[120px] border-[1.5px] border-shoorah-borderGray flex flex-col items-center justify-center text-center">
                    <div className="mt-6 md:mt-0 sm:ml-4 mb-8 flex flex-col items-center">
                      <Dialog.Title
                        as="h3"
                        className="md:text-[32px] text-3xl font-medium leading-9 text-shoorah-lightBlack dark:text-shoorah-darkBg"
                      >
                        <img
                          src={instantSupportDialogIcon}
                          alt="DropdownIcon"
                          className="dark:invert mx-auto"
                        />
                      </Dialog.Title>
                    </div>
                    <div>
                      <p className="text-lg text-gray-700 dark:text-gray-300">
                        Custom number has been added successfully! <br />
                        It will be available shortly for your customers.
                      </p>
                      <Link
                        className="w-[173px] h-[40px] bg-[#4A56DB] text-white text-lg font-normal rounded-full border border-gray-300 cursor-pointer shadow-sm flex items-center justify-center mx-auto mt-6"
                        onClick={() => setOpen(false)}
                      >
                        Got It
                      </Link>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default InstantSupportAddCustomNumber;
